import store from 'client/store'

import find from 'lodash/find'
import Vue from "vue"

export default {
  path: '/supervisor/:eventId',
  component: () => import(/* webpackChunkName: "supervisor" */ '@/components/wrapper.vue'),
  children: [{
    path: '/',
    component: () => import(/* webpackChunkName: "supervisor" */ '@/app/appLayout.vue'),
    props: {
      showMenu: false,
    },
    children: [
      { path: 'sessions', name: 'supervisor.sessions', redirect: { name: 'supervisor.home' } },
      {
        path: '/',
        name: 'supervisor.home',
        component: () => import(/* webpackChunkName: "supervisor" */ './sessions.vue'),
        beforeEnter: function (to, from, next) {
          store.dispatch('environment.setTitle', Vue.i18n.t('supervisor')).then(next)
        }
      }
    ]
  }, {
    path: 'session/:sessionId',
    component: () => import(/* webpackChunkName: "supervisor" */ '@/app/appLayout.vue'),
    beforeEnter: function (to, from, next) {
      const session = find(store.state.sessions.items, item => { return item.id === to.params.sessionId });
      const title = Vue.i18n.t('supervisor') + ': ' + session.name
      store.dispatch('environment.setTitle', title).then(() => next(), next)
    },
    children: [
      {
        path: '/',
        components: {
          default: () => import(/* webpackChunkName: "supervisor" */ '@/components/wrapper.vue'),
          menu: () => import(/* webpackChunkName: "supervisor" */ './menu.vue')
        },
        children: [
          {
            path: '/',
            name: 'supervisor.panels',
            component: () => import(/* webpackChunkName: "supervisor" */ './session/panels.vue'),
          }, {
            path: 'panel/:panelId',
            name: 'supervisor.panel',
            component: () => import(/* webpackChunkName: "supervisor" */ './session/panel.vue'),
          }, {
            path: 'results',
            component: () => import(/* webpackChunkName: "supervisor" */ './results/wrapper.vue'),
            meta: { hideHeader: true },
            children: [{
              path: '/',
              name: 'supervisor.results',
              component: () => import(/* webpackChunkName: "supervisor" */ './results/rankings.vue'),
            },{
              path: ':categoryId',
              component: () => import(/* webpackChunkName: "supervisor" */ './results/category.vue'),
              children: [{
                path: '/',
                name: 'supervisor.category',
                component: () => import(/* webpackChunkName: "supervisor" */ './results/categoryDummy.vue'),
              },{
                path: 'ranking/:rankingId',
                name: 'supervisor.ranking',
                component: () => import(/* webpackChunkName: "supervisor" */ './results/ranking.vue'),
              }],
            }]
          }
        ]
      }
    ]
  }]
}
